// Preserve scroll position when the cart drawer opens/closes.
// The cart drawer uses body { position: fixed } which resets window.scrollY to 0;
// we save before open and restore after close.
function initCartScrollPreserve() {
  const dialog = document.querySelector('.cart-drawer__dialog');
  if (!dialog) return;
  let savedScrollY = 0;
  new MutationObserver(() => {
    if (dialog.hasAttribute('open')) {
      savedScrollY = window.scrollY;
    } else {
      requestAnimationFrame(() => window.scrollTo(0, savedScrollY));
    }
  }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartScrollPreserve);
} else {
  initCartScrollPreserve();
}
